import { Col, Row } from 'antd';
import { SlicerResultPage } from 'Utils/UtilityFunctions';
import IndustriesSkeleton from './IndustriesSkeleton';

type Props = {
  sliceFlag?: boolean;
};

const defaultProps: Props = {
  sliceFlag: false,
};

const SearchIndustrySkeletonBlock = function SearchIndustrySkeletonBlock(props: Props) {
  const { sliceFlag } = props;
  const slicerGroupNumber = SlicerResultPage();

  const skeletonArray = Array.from({ length: 12 }, (_, index) => index + 1);
  const arrayLength = !sliceFlag ? 12 : slicerGroupNumber;
  return (
    <Row gutter={[24, 24]} className="Grid-width-row col-six-fix-md">
      {skeletonArray.slice(0, arrayLength).map((item) => (
        <Col span={4} className="gutter-row" key={item}>
          <IndustriesSkeleton />
        </Col>
      ))}
    </Row>
  );
};
SearchIndustrySkeletonBlock.defaultProps = defaultProps;
export default SearchIndustrySkeletonBlock;
